import { render, staticRenderFns } from "./LoadingIcon.vue?vue&type=template&id=48ff1494&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48ff1494')) {
      api.createRecord('48ff1494', component.options)
    } else {
      api.reload('48ff1494', component.options)
    }
    module.hot.accept("./LoadingIcon.vue?vue&type=template&id=48ff1494&", function () {
      api.rerender('48ff1494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/LoadingIcon.vue"
export default component.exports